var map = {
	"./Roulette-1133.json": [
		796,
		796
	],
	"./Roulette-31337.json": [
		65060,
		60
	],
	"./Roulette-address-1133.json": [
		70442,
		442
	],
	"./Roulette-address-31337.json": [
		60975,
		975
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 72026;
module.exports = webpackAsyncContext;